import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/admin/pagos_de_clientes.css';
import * as globals from '../../components/GlobalScripts.js';

const Admin_pagos_de_clientes = () => {
    const [pagos, setPagos] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const get_pagos_de_clientes = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/admin/pagos/get_pagos_de_clientes.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setPagos(response.data.pagos);
                setTotalPages(response.data.totalPages);
                if(currentPage > response.data.totalPages){
                    setCurrentPage(response.data.totalPages || 1);
                }
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los pagos",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los pagos",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        get_pagos_de_clientes(currentPage, search);
    }, [currentPage]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchChangeE = (e) => {
        get_pagos_de_clientes(currentPage, e.target.value);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    return (
        <div className="page-pagos-de-clientes container-section flex-column gap-20">
            <h3>Listado de pagos</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Filtra por nombre:</label>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChangeE(e); }}
                        className="input-primary"
                        placeholder="Presiona ENTER"
                    />
                </div>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>De</th>
                            <th>tipo</th>
                            <th>Descripción</th>
                            <th>Precio</th>
                            <th>Estatus</th>
                            <th>Fecha</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pagos.map(pago => (
                            <tr key={pago.id}>
                                <td>{pago?.de}</td>
                                <td>{pago?.type_sell}</td>
                                <td>{pago?.descripcion}</td>
                                <td>${pago?.value}{pago?.divisa}</td>
                                <td>{pago?.payment_status}</td>
                                <td>{pago?.createAt}</td>
                                <td className="table-actions">
                                    <button className="edit-button" onClick={() => navigate(`${pago.id}`)}>
                                        <svg viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Admin_pagos_de_clientes;